"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_SUPPLIES = exports.GET_CATALOG_BY_ID = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_CATALOG_BY_ID = (0, gql_1.gql)(`
   query catalog($ids: [ID!]) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          title
          tags {
            edges {
              node {
                key
                value
                id
              }
            }
          }
          createdAt
          products {
            totalCount
          }
          openTickets: linkedFrom(filter: { status: { in: OPEN } }) {
            totalCount
            edges {
              node {
                ticket {
                  title
                  linkedFrom(linkType: BLOCK, filter: { status: {in: OPEN } }) {
                    edges {
                      node {
                        ticket {
                          title
                          description
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          pendingTickets: linkedFrom(filter: { tasks: { some: { status: { in: PENDING } } } }) {
            totalCount
            edges {
              node {
                ticket {
                  title
                }
              }
            }
          }
          closedTickets: linkedFrom(filter: { status: { in: CLOSED } }) {
            totalCount
            edges {
              node {
                ticket {
                  title
                  closedAt
                }
              }
            }
          }
          productTrees (first: 1, sort: [{ createdAt: Desc }]) {
            edges {
              node {
                id
                myPermissions
                root {
                  id
                }
              }
            }
          }
          supply {
            source {
              ...on Upload {
                urls {
                  write
                }
              }
            }
          }
        }
      }
    }
  }
`);
exports.GET_CATALOG_SUPPLIES = (0, gql_1.gql)(`
  query catalogSupplies($ids: [ID!]) {
    catalogs(ids: $ids) {
      edges {
        node {
          supplies {
            edges {
              node {
                destination {
                  ...on Upload {
                    urls {
                      read
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
    `);
